import React from "react"
import ChartApi from "./ChartApi"

const ViewAcuerdoSQMCodelco: React.FC = () => <ChartApi/>

export default ViewAcuerdoSQMCodelco
